<template>
  <div class="menber">
      <!-- card背景 -->
    <div class="top_white"></div>

    <div class="card_bg">
      <div class="card_img">
        <div class="top">
          <img src="@/assets/newVcard/huangGuan.png" alt="">
          <div class="user_desc">
            <div v-if="isVCard" class="garden">
              V卡会员等级 <span>{{ memberData.VCardLevel }}</span>
            </div>
            <div v-if="!isVCard && memberData" class="garden">
              {{memberData.MemberName}}
            </div>
            <div v-if="isVCard" class="time">
              你已经开通V卡 <span style="color: #fff">{{ memberData.StartDays}}</span> 天
            </div>
            <div v-if="!isVCard && memberData" class="time">
              开通V卡可享12大权益
            </div>
          </div>
        </div>
        <div v-if="isVCard" class="bottom">
          <div class="discount div_margin">
            <div class="top_desc">会员折扣</div>
            <div class="btm_message">{{ memberData.VCardDiscount}}</div>
          </div>
          <div class="time div_margin">
            <div class="top_desc">有效时间</div>
            <div class="btm_message">{{ memberData.EndTime.slice(0,10) }}</div>
          </div>
          <div class="grow div_margin">
            <div class="top_desc">会员成长值</div>
            <div class="btm_message">{{ memberData.VCardScore }}</div>
          </div>
        </div>
        <div v-if="!isVCard" class="bottom">
          <span class="no_vcard" v-if="!isActiveTime"> 尊敬的用户，您还没有开通V卡哦~~</span>
          <span class="no_vcard" v-if="isActiveTime"> 现在开通V卡年卡，立减77元。</span>
        </div>
        <!-- 开通V卡按钮 -->
        <div v-if="!isActiveTime" class="open_card" @click="toVcard()">
          <span v-if="!isVCard">立即开通</span> <span v-if="isVCard">续费V卡</span> <span>￥298/年</span> 
        </div>
        <!-- 体验V卡 -->
        <div class="open_card1" v-if="isActiveTime">
          <div class="nian_fei" @click="toVcard()">
            <div class="price"><div class="p_v">￥</div><div class="p_num">221</div><del class="del_span">￥298</del></div>
            <div class="xian_shi">限时开卡立减77元</div>
          </div>
          <div class="ti_yan" @click="V_Tiyan()">
            <span>试用</span> ￥7.7/月
          </div>
        </div>
        <img @click="gotoDesc()" class="rule" src="@/assets/newVcard/rule.png" alt="">
      </div>
      <!-- 标题权益 -->
      <img v-if="!isBuyCard" style="width: 84%;margin: 0 auto;" src="@/assets/newVcard/jiange.png" alt="">
      <img v-if="isBuyCard" style="width: 84%;margin: 0 auto;" src="@/assets/newVcard/jiange1.png" alt="">
      <!-- 购物卡 -->
      <img style="width: 96%;margin: 0.2rem auto;" src="@/assets/newVcard/gouwuka.png" alt="">
      <!-- 折上95节 && 试吃申请-->
      <div style="display: flex;justify-content: space-between;padding:0 2%;" v-if="urlList">
        <a style="width: 49%;" ><img src="@/assets/newVcard/95zhe.png" alt=""></a>
        <a style="width: 49%;"  :href="urlList.FreeSampleUrl"><img src="@/assets/newVcard/shiChi.png" alt=""></a>
      </div>
      <!-- 购物节 -->
      <img v-if="urlList" @click="toGouWuJie()" style="margin: 0.2rem auto;" src="@/assets/newVcard/gouWuJie_start.png" alt="">
      <!-- 三联图不能点击 -->
      <img style="margin: 0.2rem auto;" src="@/assets/newVcard/three.jpg" alt="">
      <!-- 不能点击 双图 -->
      <div style="background: #d3d3d3;">
        <img src="@/assets/newVcard/two.png" alt="">
        <!-- 新品尝鲜&&专属客服 -->
        <div style="display: flex;font-size: 0;" v-if="urlList">
          <a style="width: 50%;" :href="urlList.NewProductUrl">
            <img src="@/assets/newVcard/xinPinChangXian.jpg" alt="">
          </a>
          <a style="width: 50%;margin-left: -1px;" href="https://m.gdtvdv.com/wap/shop/KFList.aspx">
            <img src="@/assets/newVcard/zhuanShuKeFu.jpg" alt="">
          </a>
        </div>
      </div>
      <div style="background: #f7f7f7;">
         <a href="https://gdtvshare.gdtvdv.com/dist/index.html#/zshb">
            <img style="margin: 0.2rem 0 0 0;" src="@/assets/newVcard/fenXiangZhuan.png" alt="">
          </a>
      </div>
      


    </div>
    <!--  -->
    <comfirm :isAlert="isAlert" :alertMsg="alertMsg" :alertTitle="alertTitle" @close="close()"></comfirm>
  </div>
</template>

<script>
import MbrService from "../../../services/mbrservice.js";
import cardService from "../../../services/card-service.js";
import comfirm from "../../alert/comfirm.vue"
export default {
  components: {
    comfirm
  },
  data() {
    return {
      isActiveTime: false, // 以上看情况注释、
      isVCard: false, //默认不是会员
      memberData: null, // 会员信息
      urlList: null, // 跳转路径列表
      alertTitle: '', // 弹窗标题
      alertMsg: '', // 弹窗文字
      isAlert: false, // 弹窗是否显示
      isBuyCard: false, // 是否显示活动时购物卡主题图片
    };
  },
  methods: {
    // 点击进入介绍界面
    gotoDesc() {
      this.$router.push({ path: "/descSlide" });
    },
    // 点击购买会员
    toVcard() {
      this.$router.push({ path: "/pay", query: {proNo: "MB1520320312462"} });
    },
    // 购物节
    toGouWuJie() {
      let d = new Date()
      let Day = d.getDate()
      if(Day < 18) {
        let num = (18 - Day)
        this.alertTitle = ""
        this.alertMsg = "每月18日会员专属购物节,专享产品超值低价购,距离活动开始时间还有"+num+"天!"
        this.isAlert = true
      } else if(Day == 18) {
        window.location.href = this.urlList.ShopDayUrl
      } else if(Day > 18) {
        this.alertTitle = "亲爱的V卡会员："
        this.alertMsg = "本月会员日活动已结束，更多巨额优惠产品请期待下期会员日，每月18号准时上线开抢噢！"
        this.isAlert = true
      }
    },
    close() {
      this.isAlert = false
    },
    IsBind() {
      new MbrService().isBind().then(res => {
        console.log(res)
        this.memberData = res.Data
        if(res.Data.IsBuy == 0) { //如果不是会员
          this.isVCard = false
        } else if(res.Data.IsBuy == 1) {  // 是会员
          this.isVCard = true
        }
      });
    },
    // 点击购买V卡体验
    V_Tiyan() {
      console.log(123123)
      this.$router.push({ path: "/pay", query: {proNo: "MB1520320312465"} });
    },
    // 获取会员信息
    LaodMemberInfo() {
      var _this = this;
      new MbrService().LaodMemberInfo().then(res => {
        if (res.ErrorCode == 0) {
          this.menName = res.Data.Name;
          this.menImg = "";
          this.menImg = this.$util(res.Data.PhotoUrl);
          if (!this.menImg) {
            this.menImg = "../../../assets/images/HeadPortrait.jpg";
          }
        }
      });
    },
    // 百度统计
    Statistics(item) {
        this.$statistics = this.$statistics.of("开卡首页|");
        this.$statistics.click(item);
    },
  },
  created() {
    this.IsBind();
    new MbrService().GetVCradActivityUrl().then(res=> {
      this.urlList = res.Data.VCradActivityInfo
    })
  },
  mounted() {
    let nowTime = Date.parse(new Date())
    let activeTimeEnd = Date.parse(new Date('2020/8/26 00:00:00'))
    let activeTimeStart = Date.parse(new Date('2020/8/21 00:00:00'))
    // 购物卡活动（限时取消）
    let buyCardEnd = Date.parse(new Date('2021/1/4 00:00:00'))
    if(nowTime < buyCardEnd) {
      this.isBuyCard = true
    } else {
      this.isBuyCard = false
    }
    if(nowTime > activeTimeStart && nowTime < activeTimeEnd) {
      this.isActiveTime = true
    } else {
      this.isActiveTime = false
    }
  }
};
</script>

<style lang="less" scoped>
.menber{
  background: #fff;
  position: relative;
  img{
    display: block;
    width: 100%;
  }
  a{
    display: block;
  }
  .top_white{
    height: 6.4rem;
    background: linear-gradient(#ffdd8b,#f9f9f9);
    position: absolute;
    z-index: 1;
    top: 1rem;
    width: 100%;
  }
  .card_bg{
    position: relative;
    padding-top: 0.2rem;
    box-sizing: border-box;
    z-index: 2;
    .card_img{
      width: 94%;
      height: 2.54rem;
      margin: 0 auto;
      background: url('../../../assets/newVcard/topIMg.png') no-repeat;
      background-size:cover;
      background-position: center 0;
      border-radius: 0.2rem;
      position: relative;
      padding-top: 0.2rem;
      box-sizing: border-box;
      margin-bottom: 0.6rem;
      .top{
        display: flex;
        overflow: hidden;
        height: 1rem;
        img{
          width: 1rem;
          margin: 0 0.2rem;
          height: 0.8rem;
        }
        .user_desc{
          width: 4rem;
          color: #fff;
          font-size: 0.54rem;
          .garden{
            color: #fff;
            font-size: 0.34rem;
            letter-spacing: 2px;
          }
          .time{
            color: #e0c587;
            font-size: 0.2rem;
            line-height: 0.56rem;
            letter-spacing: 1px;
          }
        }
      }
      .bottom{
        display: flex;
        justify-content: space-between;
        font-size: 0.2rem;
        text-align: center;
        letter-spacing: 1px;
        .no_vcard{
          color: #fff1ce;
          font-size: 0.28rem;
          padding: 0.2rem 0.2rem;
        }
        .div_margin{
          margin: 0 0.2rem;
          .top_desc{
            color: #e0c587;
            line-height: 0.35rem;
          }
          .btm_message{
            color: #e9d4a7;
            font-size: 0.35rem;
          }
          // .btm_message:nth-child(2){
          //   font-size: 0.25rem;
          // }
        }
      }
      .open_card{
        position: absolute;
        width: 84%;
        height: 0.8rem;
        background: #ed6f70;
        left: 8%;
        bottom: -0.4rem;
        font-size: 0.27rem;
        letter-spacing: 3px;
        color: #fff;
        border-radius: 0.5rem;
        text-align: center;
        line-height: 0.8rem;
        display: flex;
        justify-content: center;
        span{
          padding: 0 0.1rem;
        }
      }
      .open_card1{
        position: absolute;
        height: 0.8rem;
        width: 100%;
        bottom: -0.4rem;
        font-size: 0.27rem;
        letter-spacing: 3px;
        color: #fff;
        text-align: center;
        line-height: 0.8rem;
        display: flex;
        justify-content: center;
        .nian_fei{
          width: 44%;
          height: 0.8rem;
          background: linear-gradient(#ffcf91,#ffa067);
          border-radius: 0.5rem;
          margin-right: 1.5%;
          .price{
            font-size: 0.35rem;
            line-height: 0.6rem;
            height: 0.5rem;
            color: #fa3605;
            display: flex;
            justify-content: center;
            .del_span{
              font-size: 0.22rem;
              color: #999;
              letter-spacing: 1px;
              line-height: 0.72rem;
            }
            .p_num{
              margin-left: -0.1rem;
            }
            .p_v{
              font-size: 0.28rem;
              line-height: 0.67rem;
            }
          }
          .xian_shi{
            height: 0.3rem;
            font-size: 0.19rem;
            line-height: 0.3rem;
            color: #3d3b3b;
          }
        }
        .ti_yan{
          width: 44%;
          height: 0.8rem;
          margin-left: 1.5%;
          border-radius: 0.5rem;
          background: linear-gradient(#ed6f70,#f44f50);
        }
      }
      .rule{
        position: absolute;
        width: 0.9rem;
        height: 0.3rem;
        right: -0.1rem;
        top: 0.2rem;
      }
    }
  }
    
}
</style>


// WEBPACK FOOTER //
// src/component/home/NewMember/NewMember.vue